import { Controller } from "@hotwired/stimulus"

// AT-1207: klapt de factuurgegevens open zodra de bezoeker om een factuur vraagt.
//
// Bewust geen Bootstrap-collapse, zoals het wachtwoordblok ernaast wel doet. red2.js
// noemt het verwijderen van de Bootstrap-import als exit-criterium van fase 6, en dit
// blok zou dan opnieuw gebouwd moeten worden. Vijftien regels Stimulus overleven dat.
//
// De velden staan in de HTML op hidden. Dat is niet alleen opmaak: een verborgen veld
// wordt niet gevalideerd door de browser en niet voorgelezen, terwijl de waardes wél
// meegaan met de POST. Vult iemand het adres in, bedenkt zich, en vinkt hij uit, dan
// stuurt hij zijn adres nog steeds mee -- maar de server negeert dat, want die kijkt
// naar het vinkje. Leeggooien zou zijn werk weggooien bij een vergissing.
export default class extends Controller {
  static targets = ["toggle", "fields"]

  connect() {
    this.sync()
  }

  sync() {
    this.fieldsTarget.hidden = !this.toggleTarget.checked
  }
}
